import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { ApiService } from '../api/api.service';
import { DataService } from '../data/data.service';
import { Subject } from 'rxjs';
import { UtilityService } from '../utility/utility.service';

@Injectable({
  providedIn: 'root',
})
export class UpdateService {
  private renderer: Renderer2;
  constructor(
    private api: ApiService,
    private data: DataService,
    private utility: UtilityService,
    private rendererFactory: RendererFactory2
  ) {
    this.renderer = this.rendererFactory.createRenderer(null, null);
    // Check for updates every 15 mins
    setInterval(() => {
      this.checkForUpdates();
    }, 15 * 60 * 1000); // 15 mins in milliseconds
  }

  latestVersionAvailable = false;
  latestVersionSubject = new Subject<boolean>();

  checkForUpdates() {
    console.log('Checking for updates at ' + new Date().toLocaleString());
    let latestVersion: string;
    this.api.checkVersion().subscribe(
      (res: any) => {
        if (res && res.version) {
          latestVersion = res.version;
        }
      },
      (err) => {
        console.log(err);
      },
      () => {
        if (this.data.version !== latestVersion) {
          this.latestVersionAvailable = true;
          this.utility.alertMessage(
            'New version available',
            'Please update to the latest version to continue using the application.',
            false,
            8,
            true
          );
          this.renderer.addClass(document.body, 'update-available');
        } else {
          this.latestVersionAvailable = false;
          // this.renderer.removeClass(document.body, 'update-available');
        }
        this.latestVersionSubject.next(this.latestVersionAvailable);
      }
    );
  }

  hardRefresh() {
    window.location.reload();
  }
}
